//@ts-nocheck

import React, { useEffect, useState } from "react";
import accordionAngle from "../../../assets/headerpage-icon/accordionAngle.svg";
import { useDispatch, useSelector } from "react-redux";
import { dynamicListing } from "../../../api/idx";
import {
  changeFooterFilterPara,
  changePropertyType,
  changeSubPropertyType,
  changeSpecialFeature,
  onToggleFilter,
} from "../../../state/filterActions";

const BottomAccordion = ({
  handleOnSearch,
  setAddress,
  filter,
  setFilter,
  handlePropertyTypeChange,
}) => {
  const { cityDetailsData } = useSelector((st: any) => st?.searchFilter);
  const searchFilter = useSelector((st: any) => st?.searchFilter);
  const [accordionState, setAccordionState] = useState({
    stateInfo: true,
    citiesInfo: true,
    countiesInfo: true,
    neighborhoodsInfo: true,
    zipInfo: true,
    propInfo: true,
  });

  const [showMoreStatic, setShowMoreStatic] = useState(false);
  const [nearByPlace, setNearByPlace] = useState<any>({});
  const [showMore, setShowMore] = useState(false);
  const handleShowMore = () => {
    setShowMore(true);
  };
  const handleShowLess = () => {
    setShowMore(false);
  };

  const handleCityClick = (selectAddress: any, type: string) => {
    setAddress(selectAddress);
    setFilter((pre: any) => ({
      ...pre,
      [type]: selectAddress,
    }));
    localStorage.setItem(
      "filtervalue",
      JSON.stringify({ ...filter, [type]: selectAddress })
    );
    handleOnSearch(selectAddress);
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const dispatch = useDispatch();
  const filterValue = useSelector(
    (store) => store?.filterReducer?.footerFilter?.filterValue
  );
  const specialFeature = useSelector(
    (store) => store?.filterReducer?.specialFeature
  );

  useEffect(() => {
    console.log("--filterValue--", filterValue);
    if (filterValue) {
      (async function () {
        //@ts-ignore
        let res = await dynamicListing(filterValue);
        if (res?.status === 200) {
          setNearByPlace(res?.data?.data);
        } else {
          setNearByPlace({});
        }
        console.log("--res_city_name--", res);
      })();
    }
  }, [filterValue]);
  // console.log("dynamicListing", dynamicListing);
  return (
    <>
      <section className="disclaimer-container">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="content-area">
                <h4 className="disclaimer-heading">Disclaimer</h4>
                <p className="disclaimer-content">
                  The data relating to real estate for sale or rent on this
                  website comes in part from participation in the Internet Data
                  Exchange (IDX) program of one or more Multiple Listing
                  Services (MLS). The listing broker is identified on each
                  property’s detail page. Some properties listed for sale on
                  this site may have since sold or may no longer be available.
                  All information provided is deemed reliable but is not
                  guaranteed and should be independently verified. IDX
                  information is provided exclusively for consumers’ personal,
                  non-commercial use and may not be used for any purpose other
                  than to identify prospective properties consumers may be
                  interested in purchasing. Listing information © 2025.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="bottom-footers">
        <div className="bottom-filter">
          <div className="row">
            <div className="col-xl-2 col-lg-3 col-md-4">
              <div
                className={`bottom-accordion statAc ${
                  accordionState.stateInfo ? "showAc" : ""
                }`}
              >
                <div
                  className="ac-header"
                  onClick={() =>
                    setAccordionState({
                      ...accordionState,
                      stateInfo: !accordionState.stateInfo,
                    })
                  }
                >
                  <span>States</span>
                  <img src={accordionAngle} alt="" />
                </div>
                <div className="ac-body">
                  <ul>
                    {nearByPlace?.states ? (
                      nearByPlace.states
                        .slice(0, showMore ? nearByPlace.states.length : 6)
                        .map((each: any) => (
                          <li>
                            <a
                              key={each}
                              onClick={() => {
                                // handleCityClick(each, "state")
                                // dispatch(
                                //   changeFooterFilterPara({
                                //     filterKey: "stateOrProvince",
                                //     filterValue: each,
                                //   })
                                // );
                                // dispatch(onToggleFilter())
                              }}
                            >
                              {each}
                            </a>
                          </li>
                        ))
                    ) : (
                      <>
                        {" "}
                        <li>
                          <a
                            onClick={() => {
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "stateOrProvince",
                                  filterValue: "NE",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            Nebraska
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "stateOrProvince",
                                  filterValue: "IA",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            Iowa
                          </a>
                        </li>
                      </>
                    )}
                    {nearByPlace?.states?.length > 6 && (
                      <li>
                        {showMore ? (
                          <p className="show-less" onClick={handleShowLess}>
                            <i className="fa-solid fa-plus"></i> Show Less
                          </p>
                        ) : (
                          <p className="show-more" onClick={handleShowMore}>
                            {" "}
                            <i className="fa-solid fa-plus"></i>{" "}
                            <a>Show More</a>
                          </p>
                        )}
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4">
              <div
                className={`bottom-accordion ${
                  accordionState.citiesInfo ? "showAc" : ""
                }`}
              >
                <div
                  className="ac-header"
                  onClick={() =>
                    setAccordionState({
                      ...accordionState,
                      citiesInfo: !accordionState.citiesInfo,
                    })
                  }
                >
                  <span>Cities</span>
                  <img src={accordionAngle} alt="" />
                </div>
                <div className="ac-body">
                  <ul>
                    {nearByPlace?.cities ? (
                      nearByPlace.cities
                        .slice(0, showMore ? nearByPlace.cities.length : 6)
                        .map((each: any) => (
                          <li>
                            <a
                              key={each}
                              onClick={() => {
                                // handleCityClick(each, "city")
                                dispatch(
                                  changeFooterFilterPara({
                                    filterKey: "city",
                                    filterValue: each,
                                  })
                                );
                                dispatch(onToggleFilter());
                              }}
                            >
                              {each}
                            </a>
                          </li>
                        ))
                    ) : (
                      <>
                        {" "}
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("Omaha", "city")
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "city",
                                  filterValue: "Omaha",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            {" "}
                            Omaha,NE
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("Elkhorn", "city")
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "city",
                                  filterValue: "Elkhorn",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            Elkhorn,NE
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("Gretna", "city")
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "city",
                                  filterValue: "Gretna",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            Gretna,NE
                          </a>
                        </li>
                      </>
                    )}

                    {nearByPlace?.cities?.length > 6 && (
                      <li>
                        {showMore ? (
                          <p className="show-less" onClick={handleShowLess}>
                            <i className="fa-solid fa-plus"></i> Show Less
                          </p>
                        ) : (
                          <p className="show-more" onClick={handleShowMore}>
                            {" "}
                            <i className="fa-solid fa-plus"></i>{" "}
                            <a>Show More</a>
                          </p>
                        )}
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4">
              <div
                className={`bottom-accordion ${
                  accordionState.countiesInfo ? "showAc" : ""
                }`}
              >
                <div
                  className="ac-header"
                  onClick={() =>
                    setAccordionState({
                      ...accordionState,
                      countiesInfo: !accordionState.countiesInfo,
                    })
                  }
                >
                  <span>Counties</span>
                  <img src={accordionAngle} alt="" />
                </div>
                <div className="ac-body">
                  <ul>
                    {nearByPlace?.counties ? (
                      nearByPlace.counties
                        .slice(0, showMore ? nearByPlace.counties.length : 6)
                        .map((each: any) => (
                          <li>
                            <a
                              key={each}
                              onClick={() => {
                                // handleCityClick(each, "countyOrParish")
                                dispatch(
                                  changeFooterFilterPara({
                                    filterKey: "countyOrParish",
                                    filterValue: each,
                                  })
                                );
                                dispatch(onToggleFilter());
                              }}
                            >
                              {each}
                            </a>
                          </li>
                        ))
                    ) : (
                      <>
                        {" "}
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("Douglas", "city")
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "countyOrParish",
                                  filterValue: "Douglas County",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            Douglas County
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("Deschutes", "city")
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "countyOrParish",
                                  filterValue: "Deschutes County",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            Deschutes County
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("Pottawattamie", "city")
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "countyOrParish",
                                  filterValue: "Pottawattamie County",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            Pottawattamie County
                          </a>
                        </li>
                      </>
                    )}

                    {nearByPlace?.counties?.length > 6 && (
                      <li>
                        {showMore ? (
                          <p className="show-less" onClick={handleShowLess}>
                            <i className="fa-solid fa-plus"></i> Show Less
                          </p>
                        ) : (
                          <p className="show-more" onClick={handleShowMore}>
                            {" "}
                            <i className="fa-solid fa-plus"></i>{" "}
                            <a>Show More</a>
                          </p>
                        )}
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4">
              <div
                className={`bottom-accordion ${
                  accordionState.neighborhoodsInfo ? "showAc" : ""
                }`}
              >
                <div
                  className="ac-header"
                  onClick={() =>
                    setAccordionState({
                      ...accordionState,
                      neighborhoodsInfo: !accordionState.neighborhoodsInfo,
                    })
                  }
                >
                  <span>Neighborhoods</span>
                  <img src={accordionAngle} alt="" />
                </div>
                <div className="ac-body">
                  <ul>
                    {nearByPlace?.neighborhoods ? (
                      nearByPlace.neighborhoods
                        .slice(
                          0,
                          showMore ? nearByPlace.neighborhoods.length : 6
                        )
                        .map((each: any) => (
                          <li>
                            <a
                              key={each}
                              onClick={() => {
                                // handleCityClick(each, "")
                                // dispatch(
                                //   changeFooterFilterPara({
                                //     filterKey: "neighborhoods",
                                //     filterValue: "Pottawattamie County",
                                //   })
                                // );
                                // dispatch(onToggleFilter())
                              }}
                            >
                              {each}
                            </a>
                          </li>
                        ))
                    ) : (
                      <>
                        {" "}
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("Old Bend", "city")
                            }}
                          >
                            Old Bend
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("River West", "city")
                            }}
                          >
                            River West
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("Orchard District", "city")
                            }}
                          >
                            Orchard District
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("Century West", "city")
                            }}
                          >
                            Century West
                          </a>
                        </li>
                      </>
                    )}

                    {nearByPlace?.neighborhoods?.length > 6 && (
                      <li>
                        {showMore ? (
                          <p className="show-less" onClick={handleShowLess}>
                            <i className="fa-solid fa-plus"></i> Show Less
                          </p>
                        ) : (
                          <p className="show-more" onClick={handleShowMore}>
                            {" "}
                            <i className="fa-solid fa-plus"></i>{" "}
                            <a>Show More</a>
                          </p>
                        )}
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4">
              <div
                className={`bottom-accordion ${
                  accordionState.zipInfo ? "showAc" : ""
                }`}
              >
                <div
                  className="ac-header"
                  onClick={() =>
                    setAccordionState({
                      ...accordionState,
                      zipInfo: !accordionState.zipInfo,
                    })
                  }
                >
                  <span>Zip Codes</span>
                  <img src={accordionAngle} alt="" />
                </div>
                <div className="ac-body">
                  <ul>
                    {nearByPlace?.zipCodes ? (
                      nearByPlace.zipCodes
                        .slice(0, showMore ? nearByPlace.zipCodes.length : 6)
                        .map((each: any) => (
                          <li>
                            <a
                              key={each}
                              onClick={() => {
                                // handleCityClick(each, "zip")
                                dispatch(
                                  changeFooterFilterPara({
                                    filterKey: "zip",
                                    filterValue: each,
                                  })
                                );
                                dispatch(onToggleFilter());
                              }}
                            >
                              {each}
                            </a>
                          </li>
                        ))
                    ) : (
                      <>
                        {" "}
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("97703", "city")
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "zip",
                                  filterValue: "97703",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            97703
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("97701", "city")
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "zip",
                                  filterValue: "97701",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            97701
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => {
                              // handleCityClick("97702", "city")
                              dispatch(
                                changeFooterFilterPara({
                                  filterKey: "zip",
                                  filterValue: "97702",
                                })
                              );
                              dispatch(onToggleFilter());
                            }}
                          >
                            97702
                          </a>
                        </li>
                      </>
                    )}

                    {nearByPlace?.zipCodes?.length > 6 && (
                      <li>
                        {showMore ? (
                          <p className="show-less" onClick={handleShowLess}>
                            <i className="fa-solid fa-plus"></i> Show Less
                          </p>
                        ) : (
                          <p className="show-more" onClick={handleShowMore}>
                            {" "}
                            <i className="fa-solid fa-plus"></i>{" "}
                            <a>Show More</a>
                          </p>
                        )}
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4">
              <div
                className={`bottom-accordion ${
                  accordionState.propInfo ? "showAc" : ""
                }`}
              >
                <div
                  className="ac-header"
                  onClick={() =>
                    setAccordionState({
                      ...accordionState,
                      propInfo: !accordionState.propInfo,
                    })
                  }
                >
                  <span>Property Types</span>
                  <img src={accordionAngle} alt="" />
                </div>
                <div className="ac-body">
                  <ul>
                    {showMoreStatic ? (
                      <>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("House")
                            dispatch(changePropertyType("Residential"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>House</a>
                        </li>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("Townhouse")
                            dispatch(changeSubPropertyType("Townhouse"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>Townhouse</a>
                        </li>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("Condominium")
                            dispatch(changeSubPropertyType("Condominium"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>Condo</a>
                        </li>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("Multi Family")
                            dispatch(changeSubPropertyType("Multi Family"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>Multi-family</a>
                        </li>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("Luxury")
                            dispatch(
                              changeSpecialFeature({
                                luxury: specialFeature?.luxury ? null : true,
                              })
                            );
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>Luxury</a>
                        </li>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("Villa/Patio Home")
                            dispatch(changeSubPropertyType("Villa/Patio Home"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>Villa</a>
                        </li>
                        <li
                          onClick={() => {
                            dispatch(changeSubPropertyType("Farm"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>Farms</a>
                        </li>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("Land")
                            dispatch(changePropertyType("Land"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>Land</a>
                        </li>
                      </>
                    ) : (
                      <>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("House")
                            dispatch(changePropertyType("Residential"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>House</a>
                        </li>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("Townhouse")
                            dispatch(changeSubPropertyType("Townhouse"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>Townhouse</a>
                        </li>
                        <li
                          onClick={() => {
                            // handlePropertyTypeChange("Condominium")
                            dispatch(changeSubPropertyType("Condominium"));
                            dispatch(onToggleFilter());
                          }}
                        >
                          <a>Condo</a>
                        </li>
                      </>
                    )}
                    {showMoreStatic ? (
                      <li>
                        <p
                          className="show-less"
                          onClick={() => setShowMoreStatic(false)}
                        >
                          <i className="fa-solid fa-plus"></i> <a>Show Less</a>
                        </p>
                      </li>
                    ) : (
                      <li>
                        <p
                          className="show-more"
                          onClick={() => setShowMoreStatic(true)}
                        >
                          {" "}
                          <i className="fa-solid fa-plus"></i> <a>Show More</a>
                        </p>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BottomAccordion;
